import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import verificationStatus from 'data/verificationStatus';
import { verificationApi } from 'store/slices/verification-api';
import { preloadQueries } from 'utils/preloading';

export const Route = createFileRoute('/_authenticated/verification')({
  beforeLoad: async ({ location }) => {
    const [res] = await preloadQueries(
      verificationApi.endpoints.getVerificationStatus.initiate(),
    );

    const status = res.data;
    const { actions } = status;

    const outstandingSteps =
      actions.filter(
        (x: any) =>
          x.statusCode === verificationStatus.PendingUser ||
          x.statusCode === verificationStatus.NotStarted,
      ).length > 0;

    const submittedSteps =
      actions.filter(
        (x: any) => x.statusCode === verificationStatus.PendingProvider,
      ).length > 0;
   
    if (submittedSteps && !outstandingSteps) {
      // IF USER HAS SUBMITTED, BUT NOT VERIFIED, REDIRECT TO SUBMITTED PAGE
      const redirectUrl = `/verification/submitted`;
      if (location.pathname != redirectUrl) {
        throw redirect({ to: redirectUrl });
      }
    }

    if (!outstandingSteps && actions.length > 0 && !submittedSteps) {
      // IF USER IS VERIFIED, REDIRECT TO SETTINGS
      const redirectUrl = `/settings`;
      if (location.pathname != redirectUrl) {
        throw redirect({ to: redirectUrl });
      }
    }
  },
  component: Verification,
});

function Verification() {
  return (
    <div className="static lg:relative w-full h-full overflow-auto">
      <Outlet />
    </div>
  );
}
